<template>
    <div id="modal_component" class="modal-component" v-if="modal">
        <div class="modal-area">
            <div class="modal-overlay">
                <div class="modal-overlay-inside">
                    <div class="modal-outer">
                        <div class="modal-close" @click="progress ? '' : hideModal()"></div>
                        <div class="modal-inner">
                            <form>
                                <b-row>
                                    <b-col lg="12"
                                           cols="12">
                                        <p class="p2 text-left">Are you sure you want to buy this package?<br>Pay with:</p>
                                    </b-col>
                                </b-row>

                                <b-row v-if="select">
                                    <b-col lg="4">
                                        <div class="form-item form-item-select" :class="{ 'field-error': errors.has('country') }">
                                            <div class="select-outer">
                                                <input type="text"
                                                       v-model="selected"
                                                       @focus="openList = true"
                                                       @blur="openList = hoverList ? true : false"
                                                       :readonly="true">
                                                <ul v-show="openList" style="text-align: left">
                                                    <li v-for="single in packets"
                                                        v-if="single >= select"
                                                        :class="{ 'active': '$' + single === selected }"
                                                        @click="setItem(single), openList = false"
                                                        @mouseover="hoverList = true"
                                                        @mouseleave="hoverList = false">FND {{ single }}</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col lg="12"
                                           cols="12">
                                        <div class="form-item form-item-radio">
                                            <label for="transfer_money"
                                                   class="form-label text-left">
                                                Transfer money or use money from FutureAdPro account
                                            </label>
                                            <input  id="transfer_money"
                                                    name="payment_method"
                                                    data-vv-rules="required"
                                                    data-vv-as="payment method"
                                                    type="radio"
                                                    value="transferMoney"
                                                    v-model="paymentType"
                                                    @click="hideErrors()">
                                            <div class="check"></div>
                                        </div>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col lg="12"
                                           cols="12">
                                        <div class="form-item form-item-radio">
                                            <label for="futuro_account"
                                                   class="form-label text-left">
                                                FuturoNetwork account
                                            </label>
                                            <input  id="futuro_account"
                                                    name="payment_method"
                                                    data-vv-rules="required"
                                                    data-vv-as="payment method"
                                                    type="radio"
                                                    value="futurenetAccount"
                                                    v-model="paymentType"
                                                    @click="hideErrors()">
                                            <div class="check"></div>
                                        </div>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col lg="12"
                                           cols="12">
                                        <div class="form-item form-item-radio">
                                            <label for="code"
                                                   class="form-label text-left">
                                                FuturoNetwork voucher
                                            </label>
                                            <input  id="code"
                                                    name="payment_method"
                                                    data-vv-rules="required"
                                                    data-vv-as="payment method"
                                                    type="radio"
                                                    value="code"
                                                    v-model="paymentType"
                                                    @click="hideErrors()">
                                            <div class="check"></div>
                                        </div>
                                    </b-col>
                                    <b-col lg="1"
                                           cols="1"></b-col>
                                    <b-col lg="6"
                                           cols="6">
                                        <div class="modal-form-item"
                                             v-if="paymentType === 'code'">
                                            <input type="text"
                                                   name="code"
                                                   v-model="code"
                                                   v-validate
                                                   data-vv-rules="required">
                                        </div>
                                    </b-col>
                                </b-row>

                                <b-row style="display: none">
                                    <b-col lg="12"
                                           cols="12">
                                        <div class="form-item form-item-radio">
                                            <label for="futuro_account"
                                                   class="form-label text-left">
                                                Bitcoin
                                            </label>
                                            <input  id="bitcoin"
                                                    name="payment_method"
                                                    data-vv-rules="required"
                                                    data-vv-as="payment method"
                                                    type="radio"
                                                    value="bitcoin"
                                                    v-model="paymentType"
                                                    @click="hideErrors()">
                                            <div class="check"></div>
                                        </div>
                                    </b-col>
                                </b-row>

                                <p class="field-error--description" v-show="codeNotFound">Incorrect code</p>
                                <p class="field-error--description" v-show="notEnoughMoney">Not enough money to buy a package</p>
                                <b-row v-if="paymentType === 'futurenetAccount'">
                                    <b-col lg="12">
                                        <p class="p1 text-right">FuturoNetwork account balance:<br>FND {{ available }}</p>
                                    </b-col>
                                </b-row>
                                <div class="form-actions text-right">
                                    <a class="button--cancel" @click="progress ? '' : hideModal()">cancel</a>
                                    <a class="button--primary"
                                       :class="{ 'disabled' : progress || !paymentType || (paymentType === 'code' && !code) || notEnoughMoney }"
                                       @click="progress ? '' : confirm(paymentType)">Pay</a>
                                </div>
                            </form>
                            <div class="data-loader__modal"
                                 v-if="progress"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        dependencies: ['money'],
        data () {
            return {
                progress        : false,
                paymentType     : false,
                code            : null,
                packetId        : null,
                codeNotFound    : false,
                notEnoughMoney  : false,
                packets         : [100, 250, 500, 1000, 5000, 10000, 25000],
                selected        : false,
                openList        : false,
                hoverList       : false
            }
        },
        computed: {
            available () {
                return this.money.format(this.$store.getters.user.moneyBalance, 'fnd');
            },
            message () {
                return this.$store.getters.modals.buyPacket.message;
            },
            modal () {
                return this.$store.getters.modals.buyPacket.visible;
            },
            packet () {
                return this.$store.getters.modals.buyPacket.packet;
            },
            select () {
                return this.$store.getters.modals.buyPacket.select;
            },
            current () {
                return this.$store.getters.modals.buyPacket.current;
            },
            upgrade () {
                return this.$store.getters.modals.buyPacket.upgrade;
            },
        },
        methods: {
            hideErrors () {
                this.codeNotFound = false;
                this.notEnoughMoney = false;
            },
            hideModal () {
                this.paymentType = false;
                this.code = null;
                this.hideErrors();
                let params = {
                    modal: 'buyPacket',
                    data: {
                        visible: false,
                        message: '',
                        packet: 0
                    }
                };
                this.$store.commit('modals', params);
            },
            setItem (item) {
                this.packet.create(item);
                this.selected = 'FND ' + item;
            },
            confirm (method) {
                if (!method) {
                    return;
                }

                if (method === 'code' && !this.code) {
                    return;
                }

                if (this.upgrade) {
                    if ((parseFloat(this.packet.value) - parseInt(this.current)) > parseFloat(this.available) && this.paymentType === 'futurenetAccount') {
                        this.notEnoughMoney = true;
                        return;
                    }
                } else {
                    if (parseFloat(this.packet.value) > parseFloat(this.available) && this.paymentType === 'futurenetAccount') {
                        this.notEnoughMoney = true;
                        return;
                    }
                }

                this.progress = true;
                this.codeNotFound = false;
                this.notEnoughMoney = false;

                this.packet.buy(method, this.code, this.upgrade).then(() => {
                    this.progress = false;
                    this.hideModal();
                }, error => {
                    this.codeNotFound = error.status === 404;
                    this.notEnoughMoney = error.status === 422;
                    this.progress = false;
                    this.loader = false;
                });
            }
        },
        watch: {
            packet () {
                if (this.select) {
                    this.selected = 'FND ' + this.$store.getters.modals.buyPacket.select;
                    this.packet.create(this.$store.getters.modals.buyPacket.select);
                }

                if (this.upgrade) {
                    this.packetId = this.$store.getters.modals.buyPacket.upgrade;
                }
            }
        }
    }
</script>

<style lang="scss" scoped>

    @import '../../../../../assets/scss/_colors.scss';

    .modal-form-item {
        margin: 0;
    }

    .modal-outer {
        padding: 30px;
    }

    .form-actions {
        margin-top: 20px;
    }

    a {
        &.disabled {
            background-color: $gray;
            cursor: default;
            &:hover {
                background-color: $gray;
                cursor: default;
            }
        }
    }

    .field-error--description {
        text-align: left;
        padding-left: 30px;
    }
</style>



// WEBPACK FOOTER //
// src/components/layout/partials/section/modals/BuyPacket.vue